<div class="backdrop"></div>
<div #boundingBox class="BoundingBox">
  <div #popup class="custom-popup" cdkDrag cdkDragBoundary=".BoundingBox">
    <div class="popup-header" cdkDragHandle>
      <span>{{ title }}</span>
      <button class="close-btn" (click)="closePopup()">✖</button>
    </div>


    <div class="popup-content">

      <!-- Dynamic component (highest priority) -->
      <ng-container #contentContainer></ng-container>

      <!-- ✅ File Viewer -->
      <iframe *ngIf="safeFileUrl"
              class="file-viewer-frame"
              [src]="safeFileUrl"
              style="width:100%; height:100%; border:none">
      </iframe>

      <!-- Existing report viewer -->
      <iframe *ngIf="!safeFileUrl && reportUrl"
              class="report-frame"
              [src]="reportUrl"
              (load)="onIframeLoad()"
              style="width:100%; height:100%; border:none">
      </iframe>

      <!-- Custom HTML (last priority) -->
      <div *ngIf="!safeFileUrl && !reportUrl && customHtml"
           [innerHTML]="customHtml">
      </div>

    </div>    <div class="resize-handle" (mousedown)="startResize($event)"></div>
  </div>
</div>
